<template>
  <div class="common__main-contener">
    <div class="common__main-content">
      <ValidationProvider rules="required|countWords" v-slot="{ errors }">
        <textarea v-model="comment" class="common-textarea" :disabled="isConfirm" />
        <div class="text-danger">{{ errors[0] }}</div>
      </ValidationProvider>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import { ValidationProvider, extend } from 'vee-validate'

extend('countWords', {
  message: 'Comment not within the specified number of characters (from 125 to 300 words).',
  validate(value: string): boolean {
    const wordCount = (value).replace(/(,|\.|:|;|!|\?|\s)+/g, ' ').trim().split(' ').length
    if (wordCount < 125 || wordCount > 300) {
      return false
    }
    return true
  },
})

@Component({
  components: {
    ValidationProvider,
  },
})
export default class ClassRecordCommonRecord extends Vue {
  @Prop() isConfirm!: boolean

  @Prop() value!: string

  private get comment(): string {
    return this.value || ''
  }

  private set comment(comment: string) {
    this.$emit('input', comment)
  }
}
</script>

<style scoped>
textarea {
  border-radius: 5px;
  border-style: none;
  background-color: white;
  margin: 5px 0px;
  width: 100%;
  height: 400px;
}
</style>
